var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#858186}.st1{fill:#ff6868}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3 37.8c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c-.1 2.2-1.9 4-4 4zm0-6.8c-1.6 0-2.8 1.3-2.8 2.8 0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8C10 32.3 8.8 31 7.3 31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9 46.6H.4l-.1-.4c-.2-.6-.3-1.3-.3-2 0-2.6 1.3-4.8 3.4-6.2l.4-.3.3.4c.8.9 1.9 1.4 3 1.4 1.2 0 2.4-.5 3-1.4l.3-.4.4.3c2.2 1.4 3.4 3.6 3.4 6.2 0 .7-.1 1.3-.3 2v.4zM1.3 45.4h11.9c.1-.4.1-.8.1-1.2 0-2-.9-3.7-2.5-4.9-1 .9-2.3 1.4-3.6 1.4s-2.7-.5-3.6-1.4c-1.6 1.2-2.5 3-2.5 4.9 0 .5.1.8.2 1.2zM24.1 9.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c-.1 2.2-1.8 4-4 4zm0-6.8c-1.6 0-2.8 1.3-2.8 2.8s1.3 2.8 2.8 2.8c1.5 0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8 18.2H17.2l-.1-.4c-.2-.6-.3-1.3-.3-2 0-2.6 1.3-4.8 3.4-6.2l.4-.3.4.5c.8.9 1.9 1.4 3 1.4 1.2 0 2.4-.5 3-1.4l.3-.4.4.3c2.2 1.4 3.4 3.6 3.4 6.2 0 .7-.1 1.3-.3 2v.3zm-12.7-1.1H30c.1-.4.1-.8.1-1.2 0-2-.9-3.7-2.5-4.9-1 .9-2.3 1.4-3.6 1.4s-2.7-.5-3.6-1.4c-1.6 1.2-2.5 3-2.5 4.9 0 .4.1.8.2 1.2zM24 37.8c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.7 4-4 4zm0-6.8c-1.6 0-2.8 1.3-2.8 2.8 0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.8-2.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7 46.6H17.2l-.1-.4c-.2-.6-.3-1.3-.3-2 0-2.6 1.3-4.8 3.4-6.2l.4-.3.3.4c.8.9 1.9 1.4 3 1.4s2.4-.5 3-1.4l.3-.4.4.3c2.2 1.4 3.4 3.6 3.4 6.2 0 .7-.1 1.3-.3 2v.4zm-12.6-1.2H30c.1-.4.1-.8.1-1.2 0-2-.9-3.7-2.5-4.9-1 .9-2.3 1.4-3.6 1.4s-2.7-.5-3.6-1.4c-1.6 1.2-2.5 3-2.5 4.9 0 .6.1.8.2 1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9 37.8c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6.8c-1.6 0-2.8 1.3-2.8 2.8 0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8 0-1.5-1.3-2.8-2.8-2.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5 46.6H34.1l-.2-.4c-.2-.6-.3-1.3-.3-2 0-2.6 1.3-4.8 3.4-6.2l.4-.3.3.4c.8.9 1.9 1.4 3 1.4s2.4-.5 3-1.4l.3-.4.4.3c2.2 1.4 3.4 3.6 3.4 6.2 0 .7-.1 1.3-.3 2v.4zm-12.6-1.2h11.9c.1-.4.1-.8.1-1.2 0-2-.9-3.7-2.5-4.9-1 .9-2.3 1.4-3.6 1.4-1.4 0-2.7-.5-3.6-1.4-1.6 1.2-2.5 3-2.5 4.9 0 .5.1.8.2 1.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9 28.4c-.3 0-.6-.3-.6-.6v-3.9H7.9v3.9c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-5.2h34.8v5.2c0 .4-.3.6-.6.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24 28.4c-.3 0-.6-.3-.6-.6v-8.4c0-.3.3-.6.6-.6s.6.3.6.6v8.4c0 .4-.2.6-.6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementNetwork);
export default __webpack_public_path__ + "static/media/placementNetwork.9c63774f28c2fc73ef688fd89e2cf760.svg";
export { ForwardRef as ReactComponent };